<script>
import { Bar, mixins } from 'vue-chartjs'

const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    'chartData': Object,
    'options': Object,
    'height': {
      default: 150,
      type: Number,
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
